/* eslint-disable i18next/no-literal-string */
import seriviceMeta from '../utils/services/service-meta.json';
import {Config, LangCodes} from '../utils/services/types';

import {AppSwitcherProps} from './types';

export const defaultConfig: AppSwitcherProps = {
    currentLanguage: LangCodes.en,
    environment: 'usprodms',
    currentAppId: 'hp_wolf_security',
    isHpEmail: false,
    currentAppHomeUrl: '/',
    serviceMeta: seriviceMeta as Config,
    disableAppSwitcher: false,
    i18n: {
        appSwicherMenu: 'App switcher',
        breadcrumbs: 'Breadcrumbs',
        home: 'Home',
        openAppSwitcher: 'Open app switcher',
        closeAppSwitcher: 'Close app switcher',
        myCompany: 'My Company',
        settings: 'Settings',
        tools: 'Tools',
        services: 'Services',
        expandServices: 'Toggle services menu',
        expandTools: 'Toggle tools menu',
        usersAndRoles: 'Users & Roles',
        helpAndSupport: 'Help & Support',
        ariaLabels: {
            tools: {aria: 'Toggle tools menu', toggle: 'Tools'},
            categories: {aria: 'Toggle services menu', toggle: 'Services'},
        },
    },
    loginType: 'default',
    breadcrumbs: [],
};
